<script lang="ts">
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';
  import { votingSlipTooltip } from '../util/tooltipstore';

  const onClose = (event: Event) => {
    event.stopPropagation();

    trackEvent({ action: 'click:tooltip-close' });
    votingSlipTooltip.set(undefined);
  };

  $: visible = !!$votingSlipTooltip;
</script>

<div class="container">
  {#if visible}
    <button
      class="tooltip"
      on:click={onClose}
      title={i18n('poll.tooltip.title')}
    >
      <div class="text">{$votingSlipTooltip}</div>
      <div>✕</div>
    </button>
  {/if}
  <slot />
</div>

<style>
  .container {
    position: relative;
    max-width: 10rem;
    flex-grow: 1;
  }
  .tooltip {
    position: absolute;
    bottom: 150%;
    right: 0;
    border-radius: 3px;
    background-color: var(--color-alt_bg);
    color: black;
    width: 230px;
    font-weight: 400;
    font-size: var(--font-size-m);
    padding: var(--spacing-10);
    display: flex;
  }

  .tooltip:before {
    content: ' ';
    display: block;
    position: absolute;
    top: 100%;
    right: 30%;
    border-width: var(--spacing-16);
    border-color: transparent;
    border-style: solid;
    width: var(--spacing-16);
    height: var(--spacing-16);
  }

  .tooltip:after {
    content: ' ';
    display: block;
    position: absolute;
    top: calc(100% - 2px);
    right: 30%;
    border-width: var(--spacing-16);
    border-color: transparent;
    border-top-color: var(--color-alt_bg);
    border-style: solid;
    width: var(--spacing-16);
    height: var(--spacing-16);
  }

  .text {
    padding: var(--spacing-8);
  }
</style>
